import { initNavigation } from "./modules/navigation.js";
import { initHeaderWidget } from "./modules/header-widget.js";
import { initMegamenu } from "./modules/megamenu.js";

jQuery(function ($) {
  initNavigation($);
  initHeaderWidget($);
  initMegamenu($);

  // Legacy title highlighting is content-wide and intentionally remains global.
  $("h1, h2, h3, h4, h5, h6, .hero-title").html(function (index, html) {
    return html.replace(/\*(.*?)\*/g, '<span class="highlight">$1</span>');
  });
});
